import React from "react";
import Tooltip from "@material-ui/core/Tooltip";

export default class FancyTooltip extends React.PureComponent {
    render() {
        return (
            <Tooltip {...this.props} disableFocusListener classes={{ tooltip: "white-tooltip line-breaks" }} />
        );
    }
}